import * as React from 'react';

import * as styles from './styles.css';
import { ControlLinkButton } from '../../../../../common/components/ControlLinkButton';
import { Help } from '../../../../../common/components/Icons';

interface IHelpLinkButtonProps {
  href: string;
  onClick(e: React.MouseEvent<HTMLAnchorElement>): void;
}

export const HelpLinkButton: React.FC<IHelpLinkButtonProps> = ({ href, onClick }) => {
  return (
    <ControlLinkButton
      href={href}
      title="Помощь"
      className={styles['container']}
      target="_blank"
      rel="noreferrer"
      size="M"
      tooltip="Помощь"
      rounded
      onClick={onClick}
    >
      <Help />
    </ControlLinkButton>
  );
};

HelpLinkButton.displayName = 'HelpLinkButton';
